import { createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

import { BusinessCategoryListRequest, BusinessCategoryListResponse } from '@/types/business-category'
import { apiBaseQuery } from '@/utils/api'

const api = createApi({
  reducerPath: 'business-category',
  baseQuery: apiBaseQuery,
  tagTypes: ['Business category'],
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 259200, // 3 days
  endpoints: (builder) => ({
    getListBusinessCategory: builder.query<BusinessCategoryListResponse, BusinessCategoryListRequest>({
      query: (sezRegionListRequest) => ({
        ...sezRegionListRequest,
        url: '/v1/sez-regions/categories',
        providesTags: ['Business category'],
      }),
    }),
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
})

// Export hooks for usage in functional components
export const { useLazyGetListBusinessCategoryQuery, util: businessCategoriesUtil } = api

export default api
